"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomSheet = exports.BottomSheetOverlay = void 0;
const react_1 = __importStar(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const icons_1 = require("../icons");
const styles_1 = require("./styles");
const addPrefix = (suffix) => {
    const prefix = 'bottom-sheet';
    return `${prefix}-${suffix}`;
};
const BottomSheetOverlay = (props) => {
    const { isOpen, onClose } = props;
    const [contentHeight, setContentHeight] = (0, react_1.useState)(Number.MAX_VALUE);
    const contentRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        var _a;
        ((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) && setContentHeight(contentRef.current.clientHeight);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.Overlay, { "data-cy": addPrefix('overlay'), isOpen: isOpen, onClick: onClose }),
        react_1.default.createElement(styles_1.Content, { "aria-hidden": !isOpen, role: "dialog", "aria-label": "Bottom Sheet", "aria-modal": "true", "data-cy": addPrefix('content'), ref: contentRef, height: contentHeight, isOpen: isOpen }, props.children)));
};
exports.BottomSheetOverlay = BottomSheetOverlay;
const BottomSheet = (props) => {
    const { isOpen, onClose, headerText } = props;
    (0, react_1.useEffect)(() => {
        document.body.style.overflow = isOpen ? 'hidden' : 'scroll';
        const type = isOpen ? 'appOverlays.Hide' : 'appOverlays.Show';
        toggleMshopNav(type);
        return () => {
            toggleMshopNav('appOverlays.Show');
        };
    }, [isOpen]);
    const toggleMshopNav = (type) => {
        if ((0, monera_app_core_1.isClientSide)() && window.P) {
            window.P.when('mash').execute((mash) => mash.dispatchEvent({ type }));
        }
    };
    const closeBottomSheet = (e) => {
        onClose(e);
    };
    return (react_1.default.createElement(exports.BottomSheetOverlay, { isOpen: isOpen, onClose: closeBottomSheet },
        react_1.default.createElement(styles_1.BottomSheetBackground, null,
            react_1.default.createElement(styles_1.BottomSheetHeaderContainer, null,
                !!headerText && (react_1.default.createElement(styles_1.HeaderText, { bold: true, "data-cy": addPrefix('header-text') }, headerText)),
                react_1.default.createElement(styles_1.BottomSheetCloseButton, { "data-cy": addPrefix('close-button'), "aria-label": "close", tabIndex: 0, onClick: closeBottomSheet },
                    react_1.default.createElement(icons_1.RioCloseIcon, { size: 16 }))),
            props.children)));
};
exports.BottomSheet = BottomSheet;
__exportStar(require("./types"), exports);
